/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![SkipForwardIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACqUlEQVR4nK1VOYsUURDuWa9URUU0E1QcMDNT2NBhe+roxTdVMwgb7eB6Jxop4xFs6D/QXVFQE0GMFMQDVw0Fcw8QEw923cADD6rn9dj29HTPogUN3V316nvve1VfBUG5VRBdFVgbwNIG0iMYiSNq7TRfOhAjDYHkB5CcLs3qnFsLJOeB9SWy/hrwvAbS6Xq9uS4GYD1l/4HlVmFyZJ0Elk9JImBdANYHSHoDSK8A60NkWez5ST8j6wHbeSGAc24Zsl76s1Ce1anJzrmV2dharbbKfEj6JAX0oQigAqwXfeJvxnWn0xkpPCnqJkTdhSQzaepyAYyWXvJIa4UcBkHALNssNu9u+gBqzq03ns1Zp+bBYAgLQ7cZSd/lAHy30/8VDKRn/WU+zpbefzEkeeWPRllfp9MZCcdbW4gmVvfi0VXr3NzTbrdXlCdHV01KLbvAkiLLBe8/Gcf77+4jz9PAAwB0n6fnXtYHrNeA5H0CYN2LrD+JpBXfAcvH0q7FSI96gKs5ABNxGXoAYJkyKUj6AkhuI8mdQgCrmkEAZkZbAoAsJ6w0e5sjuY4kc4UARCKDKOoDiBpq71G0f4MHmDOQ3J4imbFuD8Lx5lZ/YYt5VdFOAYRha01XDuQmsp4zuhA1SsdbUmSZj3Oiq9q/iqmibzLOAoyOji4H1rsm1/YN443dSPIIWV4A6fFsfKxPXml7PZU0mufzXxqtYgLpTzzd+2ucJvI8rFSUVORCMiP6q4n0K1Fjb7BEI2qOIesXrwhTuUHAOpuAYKSHhqSrAiyHk+TIenlgZFwxKW0vGzimXcDyNDX5Zm1ole6oS5cvNY5LeB5J7tvItA3Y+EzkvednnVxSgYw5t7E79OXtoKEPrG+A5IzNk6ET5xmz7DCBQ5ZjMd8mkOi2D7P4N1dTs2YWdygxAAAAAElFTkSuQmCC)
 */
export const SkipForwardIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="m18.01 4.79-.04.04-2.18-.02a1.1 1.1 0 0 0-.77 1.87c.2.2.48.32.77.32h4.82a1.1 1.1 0 0 0 1.09-1.1V1.1a1.1 1.1 0 1 0-2.19 0v2.19l-.02.02a11.47 11.47 0 1 0-7.45 20.17v-.02a11.47 11.47 0 0 0 11.16-8.92 1.04 1.04 0 1 0-2.04-.46 9.39 9.39 0 1 1-3.15-9.29Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M8.98 10.58c-.3.65-.84 1.01-1.64 1.1v-1.65c.35-.04.68-.17.99-.38.31-.22.53-.49.65-.8h1.48v6.9H8.98v-5.17Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        fillRule="evenodd"
        d="M14.16 15.89c-.5 0-.94-.13-1.34-.39-.4-.27-.72-.67-.95-1.2a5.05 5.05 0 0 1-.35-2c0-.8.12-1.46.35-1.99.23-.54.55-.94.95-1.2.4-.27.85-.4 1.34-.4.5 0 .94.13 1.34.4.4.26.72.66.95 1.2.23.53.35 1.2.35 1.99 0 .8-.12 1.46-.35 2-.23.53-.55.93-.95 1.2-.4.26-.85.39-1.34.39Zm0-1.26c.4 0 .7-.18.9-.54.2-.37.3-.96.3-1.79 0-.83-.1-1.42-.3-1.78a.95.95 0 0 0-.9-.55c-.4 0-.71.18-.91.55a4 4 0 0 0-.29 1.78c0 .83.1 1.42.29 1.79.2.36.5.54.91.54Z"
        clipRule="evenodd"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
